module.exports = __webpack_public_path__ + "img/gdgkl-meetup-april-2.f1ea9b43.png";